module.exports = __webpack_public_path__ + "r-v3/img/ml_46_00.48c814ab.jpg";